interface SkeletonProps {
  readonly height?: number | string;
  readonly width?: number | string;
  readonly className?: string;
}

export function Skeleton({ height = 14, width = '100%', className }: SkeletonProps) {
  const style = {
    height: typeof height === 'number' ? `${height}px` : height,
    width: typeof width === 'number' ? `${width}px` : width,
  };
  return <div className={className ? `sk ${className}` : 'sk'} style={style} />;
}
